var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.0416 13.9785H7.75388C7.33778 13.9785 7 14.3104 7 14.7192C7 15.1274 7.33778 15.4598 7.75388 15.4598H11.0416C11.4578 15.4598 11.7955 15.1274 11.7955 14.7192C11.7955 14.3104 11.4578 13.9785 11.0416 13.9785Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17 9.18934C17 8.78107 16.6622 8.44922 16.2467 8.44922H12.9589C12.5428 8.44922 12.205 8.78107 12.205 9.18934C12.205 9.59815 12.5428 9.93 12.9589 9.93H16.2467C16.6622 9.93 17 9.59815 17 9.18934Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4389 9.18928C10.4389 10.1226 9.66943 10.8791 8.71943 10.8791C7.77 10.8791 7 10.1226 7 9.18928C7 8.25649 7.77 7.5 8.71943 7.5C9.66943 7.5 10.4389 8.25649 10.4389 9.18928Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.6996C17 15.6324 16.2306 16.3889 15.2806 16.3889C14.3312 16.3889 13.5612 15.6324 13.5612 14.6996C13.5612 13.7663 14.3312 13.0098 15.2806 13.0098C16.2306 13.0098 17 13.7663 17 14.6996Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.4e26f310bd7d547b939e33c03528527d.svg";
export { ForwardRef as ReactComponent };